"use client"

import { useScrollReveal } from "@/hooks/use-scroll-reveal"
import { cn } from "@/lib/utils"

interface SectionHeadingProps {
  title: string
  description?: string
  centered?: boolean
  className?: string
}

export function SectionHeading({ title, description, centered = true, className }: SectionHeadingProps) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>()

  return (
    <div
      ref={ref}
      className={cn(
        "space-y-4",
        centered && "text-center",
        isVisible ? "opacity-100" : "opacity-0 translate-y-10",
        "transition-all duration-700 ease-out",
        className,
      )}
    >
      <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl leading-normal gradient-text overflow-visible pb-1">{title}</h2>
      {description && (
        <p className="max-w-[900px] text-muted-foreground md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed mx-auto">
          {description}
        </p>
      )}
    </div>
  )
}

